import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($uibModal, Alert) {
        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    $onInit() {
        this.stApplicationGroups = new SmartTable();
        this.stCustomGroups = new SmartTable();
        this.stSmartGroups = new SmartTable();

        this.applicationGroups = this.groups.filter(({type}) => type === 'APPLICATION');
        this.customGroups = this.groups.filter(({type}) => type === 'CUSTOM');
        this.smartGroups = this.groups.filter(({type}) => !['APPLICATION', 'CUSTOM'].includes(type));
    }

    showRemoveGroupsModal() {
        const selectedIds = this.stCustomGroups.selectedIds;

        this.$uibModal
            .open({
                component: 'companyUserDirectoriesDirectoryGroupsDirectoryRemoveGroups',
                resolve: {
                    companyId: () => this.companyId,
                    groupIds: () => selectedIds,
                },
            }).result
            .then(() => {
                const groups = this.groups.filter((group) => !selectedIds.includes(group.id));
                this.groups.splice(0, this.groups.length, ...groups);
                this.$onInit();
                this.Alert('success', 'company.user-directories.directory-groups.directory.remove-groups.removed');
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/saaspass-cloud-directory/saaspass-cloud-directory.controller.js